export default __webpack_public_path__ + "static/ak-cached/24h/media/watch-screen-mobile.8122bd61.png";